import { Box, Button, Card, CardContent, Chip, Skeleton, Typography } from '@mui/material';
import { FC } from 'react';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineOppositeContent, {
	timelineOppositeContentClasses,
} from '@mui/lab/TimelineOppositeContent';
import { DateTime } from 'luxon';
import { useSelector } from 'react-redux';
import { getShipmentsOrder, getShipmentsOrderIsLoad } from 'redux/reducers/shipments/selectors';
import { CloudUpload } from '@mui/icons-material';

export type TShipmentTimeLineProps = {
	handleRequestDelivery: (e: React.MouseEvent<HTMLElement>) => void;
	handleUploadProForma: (e: React.MouseEvent<HTMLElement>) => void;
};

export const ShipmentTimeLine: FC<TShipmentTimeLineProps> = ({
	handleRequestDelivery,
	handleUploadProForma,
}) => {
	const shipmentTimeLineIsLoading = useSelector(getShipmentsOrderIsLoad);
	const shipment = useSelector(getShipmentsOrder);
	const shipmentTimeLine = shipment?.orderHistory;

	return (
		<Box>
			{shipment && !shipmentTimeLineIsLoading ? (
				<Box sx={{ maxWidth: '100vw', overflowX: 'auto', width: '100%' }}>
					<Box sx={{ minWidth: '420px', width: '100%' }}>
						<Card
							sx={{
								// minWidth: '420px',
								width: '100%',
								mb: 2,
								'&': {
									borderRadius: '12px',
								},
							}}
						>
							<CardContent>
								<Box
									sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
								>
									<Typography sx={{ fontSize: 14 }} color="primary" gutterBottom>
										Shipment Timeline
									</Typography>
								</Box>
								<Box
									sx={{
										mt: 1.5,
										// border: '1px solid #00000020',
										// borderRadius: '12px',
										m: 0,
									}}
								>
									<Timeline
										sx={{
											m: 0,
											p: 0,
											[`& .${timelineOppositeContentClasses.root}`]: {
												flex: '1 0 0',
												maxWidth: '220px',
											},
											[`& .MuiTimelineItem-root`]: {
												minHeight: '50px',
											},
											// [`& .MuiTimelineContent-root`]: {
											// 	flex: '1 0 0',
											// },
										}}
										position="right"
									>
										{shipmentTimeLine?.map((item, index) => (
											<TimelineItem key={item.statusName} color="primary">
												<TimelineOppositeContent
													color="textSecondary"
													sx={{ fontSize: '0.8rem', m: 0, pl: 0, alignItems: 'left' }}
												>
													{!!shipmentTimeLine?.[index]?.statusDate &&
														DateTime.fromISO(shipmentTimeLine?.[index]?.statusDate).toFormat(
															'yyyy-MM-dd, HH.mm',
														)}
													{shipmentTimeLine?.[index].statusCode === 'l_requested' &&
														shipment?.order?.shippingStatus === 'Unfulfilled' &&
														shipmentTimeLine?.[index].statusDate === null && (
															<Button
																variant="contained"
																color="primary"
																size="small"
																sx={{ fontSize: '.7rem', height: '24px', whiteSpace: 'nowrap' }}
																onClick={handleRequestDelivery}
															>
																Request Swiss Post Delivery
															</Button>
														)}
													{shipmentTimeLine?.[index].statusCode === 'proforma_signed' &&
														shipment?.order?.shippingStatus === 'Awaiting Signing' &&
														shipmentTimeLine?.[index].statusDate === null && (
															<Button
																variant="contained"
																color="primary"
																size="small"
																sx={{ fontSize: '.7rem', height: '24px', whiteSpace: 'nowrap' }}
																onClick={handleUploadProForma}
																// startIcon={<CloudUpload />}
															>
																{shipment?.order?.schemes === 'IOSS-IMPORT'
																	? 'Upload Invoice for IOSS order'
																	: 'Upload Signed Pro-forma Invoice'}
															</Button>
														)}
												</TimelineOppositeContent>
												<TimelineSeparator>
													<TimelineDot
														color={shipmentTimeLine?.[index]?.statusDate ? 'primary' : 'grey'}
													/>
													{index !== (shipmentTimeLine?.length ?? 0) - 1 && (
														<TimelineConnector
															sx={{
																backgroundColor: shipmentTimeLine?.[index]?.statusDate
																	? 'primary.main'
																	: '',
															}}
														/>
													)}
												</TimelineSeparator>
												<TimelineContent sx={{ pr: 0 }}>
													<Chip
														label={item.statusName}
														color={shipmentTimeLine?.[index]?.statusDate ? 'primary' : 'default'}
														size="small"
														sx={{
															fontSize: '.7rem',
															height: '20px',
															bgcolor: shipmentTimeLine?.[index]?.statusDate
																? 'primary.light'
																: 'grey.300',
															color: '#000000a5',
														}}
													/>
												</TimelineContent>
											</TimelineItem>
										))}
									</Timeline>
								</Box>
							</CardContent>
						</Card>
					</Box>
				</Box>
			) : (
				<Skeleton variant="rectangular" height="500px" sx={{ borderRadius: '12px', mb: 2 }} />
			)}
		</Box>
	);
};
